// @flow
import React, { Component } from "react";
import withStyles from "elevate-ui/withStyles";
import classNames from "classnames";
import KeyboardArrowDown from "elevate-ui-icons/KeyboardArrowDown";
import KeyboardArrowUp from "elevate-ui-icons/KeyboardArrowUp";
import MultiSelect from "elevate-ui/MultiSelect";
import { FastField } from "formik";
import enhanceWithClickOutside from "react-click-outside";
import find from "lodash/find";

import Dropdown from "./Dropdown";

type $Props = {
  className?: string,
  classes: Object,
  values: Object,
  mlsApiVersion: number,
};

type $State = {
  isOpen: boolean,
  filterObject: Object,
};

class PropertyType extends Component<$Props, $State> {
  fastFieldId = "type";
  fastFieldName = "type";

  constructor(props) {
    super(props);

    const filterObject = find(props.filters, (filter) => {
      return filter.key === "propertyType";
    });

    this.state = {
      isOpen: false,
      filterObject,
    };

    if (this.props.mlsApiVersion === 2) {
      this.fastFieldId = "type";
      this.fastFieldName = "p_propertyType";
    }
  }

  toggleDropdown = () => {
    this.setState((state) => ({ isOpen: !state.isOpen }));
  };

  handleClickOutside() {
    if (this.state.isOpen) {
      this.setState({ isOpen: false });
    }
  }

  renderDisplayText = (values: Object) => {
    if (this.props.mlsApiVersion === 2) {
      if (values.p_propertyType && values.p_propertyType.length > 1) {
        return `${values.p_propertyType[0]} + more`;
      } else if (values.p_propertyType && values.p_propertyType.length === 1) {
        return values.p_propertyType[0];
      } else {
        return "All Properties";
      }
    }

    if (values.type && values.type.length > 1) {
      return `${values.type[0]} + more`;
    } else if (values.type && values.type.length === 1) {
      return values.type;
    } else {
      return "All Properties";
    }
  };

  render() {
    const { className, classes, values } = this.props;
    const { isOpen, filterObject } = this.state;

    return (
      <div className={classes.container}>
        <div
          className={classNames(classes.root, className)}
          onClick={this.toggleDropdown}
        >
          {this.renderDisplayText(values)}{" "}
          {this.state.isOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </div>
        <Dropdown isOpen={isOpen} maxWidth={450}>
          <div className={classes.fieldContainer}>
            <FastField
              id={this.fastFieldId}
              name={this.fastFieldName}
              label="Property Type"
              component={MultiSelect}
              items={filterObject.options}
              className={classes.multiselect}
            />
          </div>
        </Dropdown>
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    display: "flex",
    flexRow: "row nowrap",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    width: 245,
    height: 48,
    margin: "8px auto 16px",
    padding: "8px 12px",
    color: theme.typography.bodyColor,
    fontFamily: "inherit",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "20px",
    backgroundColor: "#fff",
    border: theme.borders["default"],
    borderRadius: theme.globalBorderRadius,
    cursor: "default",
  },
  container: {
    position: "relative",
  },
  fieldContainer: {
    width: "100%",
  },
  multiselect: {
    minWidth: 175,
    width: "100%",
  },
});

export default withStyles(styles, { name: "PropertyType" })(
  enhanceWithClickOutside(PropertyType)
);
